module.exports = __webpack_public_path__ + "027455593675716f7cc9feace4ec7615.svg";